import FetchApi from "./Functionapi";
import moment from 'moment/moment.js';
import { objectDetial, objectHearder } from "../document/component/newDocument/objectdata/typeobject";
const FetchApis = new FetchApi();

export async function NewDocumentDeatil(jourCode,slotdetail) {

    let dataDetail = {
        ...objectDetial,
        JournalCode: jourCode,
        SlotNo: slotdetail
    }

    return await FetchApis.FethcPost(`/document/createDocumentdetail`, dataDetail).then(res => {
        if (res) {
            // console.log(res)
            return res.data;
        }
    })

}


export async function UpdateDetailList(val) {

    var datareturn = '';
    if (val.length == 0) {
        datareturn = true
    } else {
        for (let index = 0; index < val.length; index++) {
            const element = val[index];
            await FetchApis.FethcUpdate(`/document/updateDetail/${element.JournalID}`, element).then(res => {
                if (res.status == 200) {
                    // console.log(res)
                    return datareturn = true
                }
            })
        }
    }

    return datareturn;
}

export function deletedetailById(id) {
    return FetchApis.FethcDelete(`/document/detaildeleteById/${id}`).then(res => {
        return res
    })
}


export async function NewImagesInsert(data) {

    return await FetchApis.FethcPost(`/document/createDocumentSpecification`, data).then(res => {
        return res;
    })
}


// revise journal

// โหลดข้อมูลเอกสารต้นฉบับใหม่จาก server ตอนกดบันทึก (ไม่พึ่งค่าใน redux ที่อาจยังโหลดไม่เสร็จ หรือเป็นของเอกสารอื่น)
export async function getReviseSourceData(journalCode) {
    const [detail, images, headerImages] = await Promise.all([
        FetchApis.FethcGet(`/document/DocumentDetailByCode/${journalCode}`),
        FetchApis.FethcGet(`/document/DocumentSpecificByCode/${journalCode}`),
        FetchApis.FethcGet(`/journalImages/JouranlImagesByCode/${journalCode}`)
    ]);

    if (!detail || !images || !headerImages) {
        throw new Error('โหลดข้อมูลเอกสารต้นฉบับไม่สำเร็จ กรุณาลองใหม่อีกครั้ง');
    }

    return {
        dataDetail: detail.data || [],
        dataImages: images.data || [],
        datahearderImage: headerImages.data || []
    };
}

const isSuccess = (res) => res && Number(res.status) === 200 && !res.error;

// สร้างเอกสาร revise พร้อม copy detail / รูป spec / รูปเพิ่มเติม รอทุก request เสร็จก่อน return
// return { insertId, reviseCode, failed: [รายการที่ copy ไม่สำเร็จ] }
export async function createJournalRevise(dataHeader, dataDetail, dataImages, datahearderImage) {

    const timestampsnow = moment().format('YYYY-MM-DD HH:mm:ss');
    const timestampsDate = moment().format('YYYY-MM-DD');
    const userId = sessionStorage.getItem("userId")

    if (!dataHeader.StandardCode) {
        throw new Error('ไม่พบ StandardCode ของเอกสาร ไม่สามารถสร้างเลขที่ revise ได้');
    }

    var versionnow = (parseInt(dataHeader.Revise, 10) || 0) + 1;
    let reviseCode = `${dataHeader.StandardCode}-` + versionnow;

    let objectHearder = {
        JournalID: dataHeader.JournalID,
        JournalCode: reviseCode,
        Revise: versionnow,
        TransDate: timestampsDate,//วันที่เอกสาร SDSS
        JournalGroupID: dataHeader.JournalGroupID,//อ้างอิงเอกสาร Group Revies //(เอกสารบรรจุ SSD)
        ItemTypeID: dataHeader.ItemTypeID,//ประเภทสินค้า(สำลีก้าน, ลำลีก้อน ,สำลีแผน ,สำลีม้วน)
        Purpose: dataHeader.Purpose,//วัตถุประสงค์
        LastApprovedDate: timestampsDate,//วันที่ Approved ล่าสุด
        RefECN: dataHeader.RefECN,//เลขที่ ECN อ้างอิง (เลขที่เอกสาร ECN)
        PartFileECN: dataHeader.PartFileECN,//จัดเก็บไฟล์เอกสาร ECN
        UserIDRequest: dataHeader.UserIDRequest,//รหัสผู้ร้องขอเอกสาร
        CustID: dataHeader.CustID,//รหัสลูกค้า
        ItemID: dataHeader.ItemID,//รหัสสินค้า
        ItemName: dataHeader.ItemName,
        CustName: dataHeader.CustName,// ชื่อลูกค้า
        BrandID: dataHeader.BrandID,//รหัสตราสินค้า
        SpecId:dataHeader.SpecId,
        SpecName:dataHeader.SpecName,
        BOMVersion: dataHeader.BOMVersion,//อ้างอิงสูตร BOM
        PackagingDetails: dataHeader.PackagingDetails,//อธิบายการบรรจุงาน
        Remark: dataHeader.Remark,//อธิบายเพิ่มเติม
        UserIDConfirm: userId,//รหัสผู้ Confirm เอกสาร
        ConfirmDateTime: timestampsDate,//วันที่และเวลา Confirm
        Typeproduct: dataHeader.Typeproduct,
        PurposeDetail: dataHeader.PurposeDetail,
        SaleAckUserID: dataHeader.SaleAckUserID,
        FlowrunId: dataHeader.FlowrunId,
        typeDocement: dataHeader.typeDocement,
        statusflow: "101",
        stateflow: "1",
        rejectTo: "",
        recallTo: "",
        dedicatedTo: "",
        noteRevise: dataHeader.noteRevise ?? "",
        stamptimeUpdate: timestampsnow,
        updateBy: "",
        StandardCode: dataHeader.StandardCode,
        Actives: "1"
    }

    const res = await FetchApis.FethcPost(`/document/createReviseDocument`, objectHearder);
    if (!isSuccess(res) || !res.insertId) {
        throw new Error((res && res.message) || 'สร้างเอกสาร revise ไม่สำเร็จ');
    }
    if (res.duplicate) {
        // เคยสร้างเลขนี้ไปแล้ว ห้าม copy detail ซ้ำลงเอกสารเดิม
        throw new Error(`มีเอกสาร ${reviseCode} อยู่แล้ว ไม่สามารถสร้างซ้ำได้`);
    }

    const failed = [];

    // ข้อมูลที่ copy ต้องเป็นของผู้ revise (ตรงกับ UserIDConfirm ของ Header ใหม่)
    // ถ้าใช้ UserIDConfirm ของต้นฉบับ ตอน Change Flow ระบบจะมองว่าเป็นของคนอื่นแล้วลบทิ้ง
    const ownerId = objectHearder.UserIDConfirm;

    // ทำทีละ detail ตามลำดับ เพื่อให้ JournalID ของ detail ใหม่เรียงตาม SlotNo เดิม
    for (const ListDetail of dataDetail) {
        const newDetail = await createDetailRevise(reviseCode, ListDetail, timestampsnow, ownerId);
        const newDetailId = newDetail && newDetail.data && newDetail.data[0] && newDetail.data[0].JournalID;

        if (!newDetailId) {
            failed.push(`Detail ลำดับ ${ListDetail.SlotNo} (${ListDetail.ItemID || '-'})`);
            continue;
        }

        // จับคู่รูปด้วย id ของ detail เดิม (JourId) ไม่ใช่ ItemID ป้องกันรูปซ้ำ/ตกหล่น เมื่อ ItemID ซ้ำหรือว่าง
        const imageOfDetail = dataImages.filter(img => Number(img.JourId) === Number(ListDetail.JournalID));
        const results = await Promise.all(imageOfDetail.map(img => careteImagesRevise(newDetailId, img, reviseCode, timestampsnow, ownerId)));
        results.forEach((r, i) => {
            if (!isSuccess(r)) failed.push(`รูป Spec ${imageOfDetail[i].LocationPic} (Detail ลำดับ ${ListDetail.SlotNo})`);
        });
    }

    const resultsHeaderImage = await Promise.all(datahearderImage.map(img => journalImageslist(res.insertId, reviseCode, img, timestampsnow, ownerId)));
    resultsHeaderImage.forEach((r, i) => {
        if (!isSuccess(r)) failed.push(`รูปเพิ่มเติม ${datahearderImage[i].LocationPic}`);
    });

    return { ...res, reviseCode, failed };
}

function journalImageslist(jourId, revisecode, dataimages, timestampsnow, ownerId) {

    var object = {
        JournalID: "",//เลขที่ SDSS
        SlotNo: dataimages.SlotNo,//Slot No Details
        ItemID: dataimages.ItemID,//อ้างอิง Item Code Table Detail
        ItemName: dataimages.ItemName,//อ้างอิง Item Name Table Detail
        SlotNoSpec: dataimages.SlotNoSpec,//Slot No Specification
        SubjectDetails: dataimages.SubjectDetails,//พื้นที่พิมพ์หัวข้อ
        SubjectExtend:dataimages.SubjectExtend,//พื้นที่พิมพ์อธิบาย
        LocationPic: dataimages.LocationPic,//รูปภาพ
        UserIdConfirm: ownerId,//Confirm by (ผู้ revise)
        ConfirmDateTime: timestampsnow,//Confirm Date Time
        StatusFacConfirm: "1",//"Status Last confirm(โรงงาน)เพื่อส่ง Approved "
        JournalCode: revisecode,
        JourId: jourId
    }
    return FetchApis.FethcPost(`/journalImages/createJournalImages`, object);
}

function createDetailRevise(reviseCode, ListDetail, timestampsnow, ownerId) {

    var dataDeatilall = {
        JournalID: "",
        SlotNo: ListDetail.SlotNo,
        ItemID: ListDetail.ItemID,
        ItemName: ListDetail.ItemName,
        ItemGroupID: ListDetail.ItemGroupID,
        GroupRemark: ListDetail.GroupRemark,
        PkDescription: ListDetail.PkDescription,
        SpecID: ListDetail.SpecID,
        Width: ListDetail.Width,
        Depth: ListDetail.Depth,
        Height: ListDetail.Height,
        NetWeight: ListDetail.NetWeight,
        TareWeight: ListDetail.TareWeight,
        GrossWeight: ListDetail.GrossWeight,
        SizeDetails: ListDetail.SizeDetails,
        TypeSheet: ListDetail.TypeSheet,
        Barcode: ListDetail.Barcode,
        Batch1: ListDetail.Batch1,
        BatchDetail1: ListDetail.BatchDetail1,
        BatchExample1:ListDetail.BatchExample1,
        Batch2: ListDetail.Batch2,
        BatchDetail2: ListDetail.BatchDetail2,
        BatchExample2:ListDetail.BatchExample2,
        BatchNo:ListDetail.BatchNo,
        TypeBatch:ListDetail.TypeBatch,
        Remark: ListDetail.Remark,
        ColabgroupId: ListDetail.ColabgroupId,
        UserIDConfirm: ownerId,// ผู้ revise
        ConfirmDateTime: timestampsnow,
        JournalCode: reviseCode,

    }

    return FetchApis.FethcPost(`/document/createDocumentdetail`, dataDeatilall);
}


function careteImagesRevise(detailID, imageList, reviseCode, timestampsnow, ownerId) {

    var objectImages = {
        JournalID: "",//เลขที่ SDSS
        SlotNo: imageList.SlotNo,//Slot No Details
        ItemID: imageList.ItemID,//อ้างอิง Item Code Table Detail
        ItemName: imageList.ItemName,//อ้างอิง Item Name Table Detail
        SlotNoSpec: imageList.SlotNoSpec,//Slot No Specification
        SubjectDetails: imageList.SubjectDetails,//พื้นที่พิมพ์หัวข้อ
        SubjectExtend: imageList.SubjectExtend,//พื้นที่พิมพ์อธิบาย
        LocationPic: imageList.LocationPic,//รูปภาพ
        UserIdConfirm: ownerId,//Confirm by (ผู้ revise)
        ConfirmDateTime: timestampsnow,//Confirm Date Time
        StatusFacConfirm: "1",//"Status Last confirm(โรงงาน)เพื่อส่ง Approved "
        JournalCode: reviseCode,
        JourId: detailID
    }

    return FetchApis.FethcPost(`/document/createDocumentSpecification`, objectImages);
}
